<template>
  <v-app>
    <v-card>
      <v-app-bar
        color="#BEA359"
        dark
        shrink-on-scroll
        :src="`${publicPath}head.jpg`"
      >
        <template v-slot:img="{ props }">
          <v-img
            v-bind="props"
            gradient="to top right, rgba(190,163,89,.5), rgba(101,114,73,.8)"
          ></v-img>
        </template>
        <v-app-bar-title>
          <v-img
            :src="`${publicPath}rm_logo_sticker.png`"
            width="150"
          ></v-img>
        </v-app-bar-title>
      </v-app-bar>
    </v-card>
    <v-main>
      <ViewBoard/>
    </v-main>
  </v-app>
</template>

<script>
import ViewBoard from './components/ViewBoard';

export default {
  name: 'App',

  components: {
    ViewBoard,
  },

  data: () => ({
    publicPath: process.env.BASE_URL
    //
  }),
};
</script>
